/* eslint-disable react/no-this-in-sfc */
/* eslint-disable prefer-spread */

import React, { useRef, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Column,
  DataGrid,
  FilterRow,
  OperationDescriptions,
  HeaderFilter,
  Scrolling,
  Export,
  GroupPanel,
  Grouping,
  RemoteOperations,
  ColumnChooser,
  StateStoring,
  Summary,
  GroupItem,
} from 'devextreme-react/data-grid'
import { ScrollView } from 'devextreme-react/scroll-view';
import { locale } from 'devextreme/localization'
import CustomStore from 'devextreme/data/custom_store'

import RowWithTotalCount from './RowWithTotalCount.jsx'
import onFirstRun from '../../../libs/onFirstRun'
import {
  getCurrentDateForPlaceholder,
  // onKeyDown,
  validateIpAddress,
} from './utils'
import { tryAddStateClassesToDataGrid } from '../utils'
import getOnContextMenuPreparing from './contextMenu'
import { columns, onToolbarPreparing, KEY_DATA_GRID_STATE_IN_LS } from './constants'
import * as transcriptViewerActions from '../transcriptViewerActions'
// import ExportSpiner from './export/ExportSpiner'

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.material.blue.dark.compact.css'
import './TranscriptsTable.scss'

const TranscriptsTable = ({
  tryUpdateSelectedTranscripts,
  tryStopSelectionWithCheckboxes,
  clearFilter,
  removeSelectedTranscripts,
  removeTranscripts,
  trySendToEmail,
  account,
  language,
  texts,
  history,
  getTranscripts,
  onExporting,
}) => {
  locale(language);

  const dataGridRef = useRef(null);

  useEffect(() => {
    tryAddStateClassesToDataGrid({})
  }, []);

  function onContentReady() {
    document.getElementsByClassName('dx-datagrid-rowsview')[0].focus();
    onFirstRun('TranscriptsTable_onContentReady', () => {
      tryStopSelectionWithCheckboxes()
    })
    // tryUpdateSelectedTranscripts()
  }

  const dataSource = new CustomStore({
    key: 'transcriptId',
    load(loadOptions) {
      return new Promise((resolve, reject) => {
        getTranscripts({ loadOptions, history, type: 'dataGrid', resolve, reject })
      })
    },
    onLoaded: result => result,
    // remove(transcriptIds) {
    //   return new Promise((resolve, reject) => {
    //     removeTranscripts({ transcriptIds, resolve, reject })
    //   })
    // },
    // onRemoved: transcriptIds => onRemovedTranscripts({ transcriptIds, dataGridRef }),
    LoadOptions: {
      groupSummary: { summaryType: 'count' },
      requireTotalCount: true,
    },
    select: [
      'transcriptId',
      'startDate',
    ],
  });

  /* cache dataGridState */
  const customLoad = useCallback(() => {
    let dataGridState = JSON.parse(window.localStorage.getItem(KEY_DATA_GRID_STATE_IN_LS));
    if (dataGridState?.pageIndex) {
      dataGridState.pageIndex = 0; /* scroll to top of table after page reload */
    }
    return dataGridState
  }, []);
  const customSave = useCallback(dataGridState => {
    window.localStorage.setItem(KEY_DATA_GRID_STATE_IN_LS, JSON.stringify(dataGridState))
  }, []);

  window.dataGridRef = dataGridRef
  window.dataSource = dataSource

  return (
    <div className="transcripts-table">
      <DataGrid
        dataSource={dataSource}
        showBorders
        allowColumnReordering
        allowColumnResizing
        columnResizingMode="widget"
        autoNavigateToFocusedRow={false}
        // cacheEnabled={false} /* TODO: навелосипедить кеширование */
        noDataText="No matching data"
        selection={{
          mode: 'multiple',
          deferred: true,
          showCheckBoxesMode: 'onClick',
        }}
        onSelectionChanged={tryUpdateSelectedTranscripts}
        // onKeyDown={onKeyDown(dataGridRef, setFocusedRowKey)}
        height="calc(100% - 2rem)"
        onContextMenuPreparing={getOnContextMenuPreparing({
          texts, account, removeTranscripts, trySendToEmail, dataGridRef,
        })}
        onEditorPreparing={el => {
          const { parentType, dataType, name, editorOptions } = el;
          if (parentType === 'filterRow' && dataType === 'date') {
            editorOptions.placeholder = getCurrentDateForPlaceholder();
          }
          if (parentType === 'filterRow' && name === 'chatDuration') {
            editorOptions.placeholder = '00:05:43';
          }
          if (parentType === 'filterRow' && name === 'visitor.ipAddress') {
            editorOptions.placeholder = '255.255.0.0';
            const oldOnValueChanged = editorOptions.onValueChanged.bind(editorOptions);
            editorOptions.onValueChanged = validateIpAddress(oldOnValueChanged);
          }
        }}
        /* TODO: onToolbarPreparing устарел, переделать на toolbar:
         * https://js.devexpress.com/Documentation/ApiReference/UI_Components/dxDataGrid/Configuration/toolbar/
         */
        onToolbarPreparing={onToolbarPreparing({
          texts,
          dataGridRef,
          clearFilter,
          removeSelectedTranscripts,
          onExporting,
        })}
        onExporting={onExporting}
        onContentReady={onContentReady}
        ref={dataGridRef}
      >
        <RemoteOperations groupPaging paging filtering sorting grouping />
        <StateStoring /* cache dataGridState */
          enabled
          type="custom"
          customLoad={customLoad}
          customSave={customSave}
        />
        <Export
          enabled
          allowExportSelectedData
        />
        <FilterRow visible>
          <OperationDescriptions
            between={texts['filter-between']}
            contains={texts['filter-contains']}
            endsWith={texts['filter-endsWith']}
            equal={texts['filter-equal']}
            greaterThan={texts['filter-greaterThan']}
            greaterThanOrEqual={texts['filter-greaterThanOrEqual']}
            lessThan={texts['filter-lessThan']}
            lessThanOrEqual={texts['filter-lessThanOrEqual']}
            notContains={texts['filter-notContains']}
            notEqual={texts['filter-notEqual']}
            startsWith={texts['filter-startsWith']}
          />
        </FilterRow>

        <HeaderFilter
          visible
          groupInterval="day"
          texts={{
            cancel: texts['cancel'],
            emptyValue: texts['emptyValue'],
            ok: texts['ok'],
          }}
        />
        <GroupPanel
          visible
          emptyPanelText={texts['grouping-area']}
        />
        <Scrolling mode="virtual" />
        <Grouping autoExpandAll={false} />
        <ColumnChooser enabled title={texts['column-chooser']} />

        <ScrollView />

        {columns(texts).map((columnParams, ii) => (
          <Column {...columnParams} minWidth={30} key={ii} />
        ))}

        <Summary>
          <GroupItem column="visitor.name" summaryType="count" />
        </Summary>
      </DataGrid>

      <RowWithTotalCount />

      {/* buttons in the header */}
      {/* <ExportSpiner /> */}
    </div>
  );
};

TranscriptsTable.propTypes = {
  account: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
  getTranscripts: PropTypes.func.isRequired,
  onExporting: PropTypes.func.isRequired,
  tryUpdateSelectedTranscripts: PropTypes.func.isRequired,
  tryStopSelectionWithCheckboxes: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  removeSelectedTranscripts: PropTypes.func.isRequired,
  removeTranscripts: PropTypes.func.isRequired,
  trySendToEmail: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    account: state.app.account,
    language: state.app.language,
    texts: state.app.texts,
  }), dispatch => bindActionCreators({
    getTranscripts: transcriptViewerActions.getTranscripts,
    onExporting: transcriptViewerActions.onExporting,
    tryUpdateSelectedTranscripts: transcriptViewerActions.tryUpdateSelectedTranscripts,
    tryStopSelectionWithCheckboxes: transcriptViewerActions.tryStopSelectionWithCheckboxes,
    clearFilter: transcriptViewerActions.clearFilter,
    removeSelectedTranscripts: transcriptViewerActions.removeSelectedTranscripts,
    removeTranscripts: transcriptViewerActions.removeTranscripts,
    trySendToEmail: transcriptViewerActions.trySendToEmail,
  }, dispatch),
)(TranscriptsTable);

/* TODO: починить навигацию через клавиатуру */
